import { type HeaderFooterClickCustomEvent } from '@storebrand-digital/pretzel';

import type { BaseHeaderFooterLayoutConfig } from '../types';

interface ExitBase {
  label: string;
}

interface ExitDefault extends ExitBase {
  type: 'default';
  onClick?: (e: HeaderFooterClickCustomEvent) => void;
}

interface ExitAnchor extends ExitBase {
  type: 'a';
  href: string;
  onClick?: (e: HeaderFooterClickCustomEvent) => void;
}

interface ExitLink extends ExitBase {
  type: 'Link';
  pathname: string;
  state?: unknown;
  onClick?: (e: HeaderFooterClickCustomEvent) => void;
}

interface ExitButton extends ExitBase {
  type: 'button';
  onClick: (e: HeaderFooterClickCustomEvent) => void;
}

export type FormHeaderFooterExit =
  | ExitDefault
  | ExitAnchor
  | ExitLink
  | ExitButton;

export const isDefault = (exit: FormHeaderFooterExit): exit is ExitDefault =>
  exit.type === 'default';
export const isAnchorExit = (exit: FormHeaderFooterExit): exit is ExitAnchor =>
  exit.type === 'a';
export const isLinkExit = (exit: FormHeaderFooterExit): exit is ExitLink =>
  exit.type === 'Link';
export const isButtonExit = (exit: FormHeaderFooterExit): exit is ExitButton =>
  exit.type === 'button';

export interface FormHeaderFooterProviderExit {
  element: 'a' | 'button';
  label: string;
  onExitEvent?: (e: HeaderFooterClickCustomEvent) => void;
  url?: string;
}

export interface FormHeaderFooterLayoutConfig extends BaseHeaderFooterLayoutConfig {
  variant?: 'form';
  exit?: FormHeaderFooterExit;
}
